import { createClient } from '@supabase/supabase-js';

// Initialize the Supabase client with environment variables
// Using Create React App environment variable syntax
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://euncrdywffxnewlotfvx.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV1bmNyZHl3ZmZ4bmV3bG90ZnZ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIyNDgxOTAsImV4cCI6MjA2NzgyNDE5MH0.BgNmB4CQKan0wvw-soTjDptLls51sOADb_cMX8qJROw';

// Static marketing data for fallback
const MOCK_MARKETING_DATA = [
  { date: '2024-09-15', visitors: 100, channel: 'LP Total' },
  { date: '2024-10-15', visitors: 150, channel: 'LP Total' },
  { date: '2024-11-15', visitors: 200, channel: 'LP Total' },
  { date: '2024-12-15', visitors: 250, channel: 'LP Total' },
  { date: '2025-01-15', visitors: 300, channel: 'LP Total' }
];

// Log environment variable status
console.log('Supabase initialization:');
console.log('- URL:', supabaseUrl ? `${supabaseUrl.substring(0, 10)}...` : 'MISSING');
console.log('- API Key exists:', !!supabaseKey);
console.log('- Using Create React App env vars:', process.env.NODE_ENV);

// Create a single supabase client for the entire app
let supabase;
let usingMockClient = false;

// Helper to create a mock client with realistic API
const createMockClient = () => {
  usingMockClient = true;
  
  return {
    // Mock from method that returns a query builder
    from: (tableName) => {
      console.log(`Mock client: Querying table '${tableName}'`);
      
      // Return a chainable query builder that mimics Supabase's API
      return {
        select: (columns) => {
          console.log(`Mock client: Selecting columns '${columns || '*'}'`);
          return {
            eq: (column, value) => {
              console.log(`Mock client: Filtering where ${column} = ${value}`);
              return {
                lt: (column, value) => {
                  console.log(`Mock client: Filtering where ${column} < ${value}`);
                  return {
                    order: (column, { ascending }) => {
                      console.log(`Mock client: Ordering by ${column} ${ascending ? 'ASC' : 'DESC'}`);
                      return {
                        then: (callback) => callback({
                          data: MOCK_MARKETING_DATA,
                          error: null
                        })
                      };
                    }
                  };
                },
                order: (column, { ascending }) => {
                  console.log(`Mock client: Ordering by ${column} ${ascending ? 'ASC' : 'DESC'}`);
                  return {
                    then: (callback) => callback({
                      data: MOCK_MARKETING_DATA,
                      error: null
                    })
                  };
                }
              };
            },
            lt: (column, value) => {
              console.log(`Mock client: Filtering where ${column} < ${value}`);
              return {
                eq: (column, value) => {
                  console.log(`Mock client: Filtering where ${column} = ${value}`);
                  return {
                    order: (column, { ascending }) => {
                      console.log(`Mock client: Ordering by ${column} ${ascending ? 'ASC' : 'DESC'}`);
                      return {
                        then: (callback) => callback({
                          data: MOCK_MARKETING_DATA,
                          error: null
                        })
                      };
                    }
                  };
                },
                order: (column, { ascending }) => {
                  console.log(`Mock client: Ordering by ${column} ${ascending ? 'ASC' : 'DESC'}`);
                  return {
                    then: (callback) => callback({
                      data: MOCK_MARKETING_DATA,
                      error: null
                    })
                  };
                }
              };
            },
            order: (column, { ascending }) => {
              console.log(`Mock client: Ordering by ${column} ${ascending ? 'ASC' : 'DESC'}`);
              return {
                then: (callback) => callback({
                  data: MOCK_MARKETING_DATA,
                  error: null
                })
              };
            }
          };
        }
      };
    }
  };
};

try {
  // Validate that we have the required parameters
  if (!supabaseUrl || !supabaseKey) {
    throw new Error('Missing Supabase URL or API key in environment variables');
  }
  
  // Create the real Supabase client
  supabase = createClient(supabaseUrl, supabaseKey);
  console.log('✅ Supabase client created successfully');
  
  // Test the connection with a simple query
  supabase.from('marketing_visitor_data')
    .select('count', { count: 'exact', head: true })
    .then(({ error }) => {
      if (error) {
        console.warn('⚠️ Supabase connection test failed:', error.message);
        console.warn('Will continue with real client but queries may fail');
      } else {
        console.log('✅ Supabase connection test successful');
      }
    })
    .catch(err => {
      console.warn('⚠️ Supabase connection test error:', err.message);
    });
    
} catch (error) {
  console.error('❌ Error creating Supabase client:', error.message);
  console.warn('⚠️ Falling back to mock Supabase client for development');
  
  // Create a mock client for development if real client fails
  supabase = createMockClient();
}

// Export the client and a flag indicating if we're using a mock
export default supabase;
export const isMockClient = () => usingMockClient;
